import React from "react";
import "./JobList.css";
import companyLogo from "./img/company_logo_1.png";
import { Link } from "react-router-dom";

const JobList = () => {
  const jobData = [
    {
      id: 1,
      type: "Full Time",
      title: " Copper Brazing",
      location: "Abu Dhabi, UAE",
      salary:"AED 1600-1800 +",
      imgSrc: companyLogo,
      applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
    },
    {
        id: 2,
        type: "Full Time",
        title: " Pipe Welders",
        location: "Abu Dhabi, UAE",
        salary:"AED 1600-1800 +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 3,
        type: "Full Time",
        title: "Block & Tile Mason",
        location: "Dubai",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 4,
        type: "Full Time",
        title: "Mig Welders",
        location: "Abu Dhabi",
        salary:"AED 1600  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 5,
        type: "Full Time",
        title: "CLEANING LABOURS",
        location: "SAUDI ARABIA",
        salary:"SALARY 1000 SR",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 6,
        type: "Full Time",
        title: "FIELD WORKER (LABOUR)",
        location: "SAUDI ARABIA",
        salary:"1400 SR",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 7,
        type: "Full Time",
        title: "CAR DELIVERY DRIVER",
        location: "KUWAIT",
        salary:"130KD",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 8,
        type: "Full Time",
        title: "VAN SALESMAN",
        location: "SAUDI ARABIA",
        salary: "1800-2000SR",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 9,
        type: "Full Time",
        title: "HEAVY DRIVER",
        location: "SAUDI GLOBAL SEA PORT",
        salary:"Salary: AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 10,
        type: "Full Time",
        title: "Porotta maker",
        location: "GCC COUNTRY",
        salary:"Salary: AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 11,
        type: "Full Time",
        title: "Shawarma maker",
        location: "GCC COUNTRY",
        salary:"Salary: AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 12,
        type: "Full Time",
        title: "Chinese cook",
        location: "GCC COUNTRY",
        salary:"Salary: AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 13,
        type: "Full Time",
        title: "South Indian cook",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 14,
        type: "Full Time",
        title: "Juice and sandwich maker",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 15,
        type: "Full Time",
        title: "Bike rider UAE licence ",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 16,
        type: "Full Time",
        title: "Driver oman coffee shop food delivery",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 17,
        type: "Full Time",
        title: "Tea maker",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 18,
        type: "Full Time",
        title: "Snacks maker",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 19,
        type: "Full Time",
        title: "Breakfast maker",
        location: "GCC COUNTRY",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
      {
        id: 20,
        type: "Full Time",
        title: "sales man",
        location: "SAUDI ARABIA",
        salary:"AED 1200 - 1500  +",
        imgSrc: companyLogo,
        applyLink: "https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari",
      },
  ];
  

  return (
    <section className="section" id="job-section">
      <div className="container">
        <div className="jobtoggle">
          <ul className="togglelist d-flex">
            <li className="list">
              <a href="/#" className="toggle-link">
                Latest Jobs
              </a>
            </li>
            <li className="list">
              <a href="/error" className="toggle-link">
                Recent Jobs
              </a>
            </li>
          </ul>
        </div>

        <div className="content">
          <div className="job-card-section">
            <div className="row">
              {jobData.map((job) => (
                <div className="col-md-6 col-sm-6 col-lg-3" key={job.id}>
                  <div className="utf_grid_job_widget_area">
                    <span className="job-type full-type">{job.type}</span>
                    <div className="u-content">
                      <div className="avatar box-80">
                        <a href="employer-detail.html">
                          <img
                            className="img-responsive"
                            src={job.imgSrc}
                            alt={job.title}
                          />
                        </a>
                      </div>
                      <h5>
                      <Link to={'/jobdetail'}>{job.title}</Link>
                      </h5>
                      <p className="salary">{job.salary}</p>
                      <p className="text-muted">{job.location}</p>
                    </div>
                    <div className="utf_apply_job_btn_item">
                      <a
                        href={job.applyLink}
                        className="btn job-browse-btn btn-radius br-light"
                      >
                        Apply Now
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobList;
